import React from 'react';
import { BsImageFill } from 'react-icons/bs';
import IconItemPreview from './IconItemPreview';
import './IconPreview.scss';

const IconPreview = props => {
	const { icon, from } = props;
	const { icons, amount, alignment, size } = (icon && icon.props) || {};
	const fromButton = from === 'WidgetButton';
	const iconPreviewArr = amount && new Array(Number(amount)).fill('');

	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Icon</div>}
				{fromButton ? (
					<div className="icon-container">
						<div className="icon-box" />
						<div className="icon-box" />
						<div className="icon-box" />
						<div className="icon-box" />
					</div>
				) : (
					<div className={`icons-content ${alignment}`}>
						{icons.length
							? icons.map((icon, index) =>
									icon.source ? (
										<IconItemPreview
											icon={icon}
											size={size}
											key={'icon-item-' + props.icon.id + '-' + index}
										/>
									) : (
										<div className="icon-preview" key={index}>
											<BsImageFill className="image-icon" />
										</div>
									)
							  )
							: iconPreviewArr
							? iconPreviewArr.map((_, index) => (
									<div className="icon-preview" key={index}>
										<BsImageFill className="image-icon" />
									</div>
							  ))
							: null}
					</div>
				)}
			</div>
		</div>
	);
};

export default IconPreview;
